export const USA = 'USA';
export const EUROPE = 'Europe';
export const APAC = 'APAC';

export const Regions = [
  {
    label: EUROPE,
    value: EUROPE,
  },
  {
    label: USA,
    value: USA,
  },
  {
    label: APAC,
    value: APAC,
  },
];
